import React from 'react';

const CryptoCardsList = ({ tableData, chartData, activeIndex }) => {
	const filteredData = tableData.filter(crypto => {
		if (activeIndex === null) return true
		const selectedCryptoSymbol = chartData[activeIndex]?.name
		return selectedCryptoSymbol === crypto.symbol
	})

	return (
		<div className='cards-container'>
			{filteredData.map((crypto, index) => {
				const progressWidth = crypto.allocation + '%'
				const color =
					chartData.find(c => c.name === crypto.symbol)?.color || '#ccc'
				const { name, symbol, rationale } = crypto
				return (
					<div
						key={index}
						className={`card ${color}`}
						style={{ width: '250px', margin: '10px' }}
					>
						<div className='card-header'>
							<h3>{name}</h3>
							{symbol && <p>{symbol}</p>}
						</div>
						<div className='card-body'>
							<div className='progress' style={{ marginBottom: '10px' }}>
								<div
									className='progress-bar'
									style={{ width: progressWidth, backgroundColor: color }}
								></div>
								<p>{crypto.allocation}%</p>
							</div>
							<div className='card-info'>
								{rationale && (
									<p>
										<strong>Rationale:</strong> {rationale}
									</p>
								)}
							</div>
						</div>
					</div>
				)
			})}
		</div>
	)
}

export default CryptoCardsList
